import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { wrapperStyle } from './styles';

import FacebookIcon from 'inside-out/images/facebook-icon.svg';
import TwitterIcon from 'inside-out/images/twitter-icon.svg';
import InstagramIcon from 'inside-out/images/instagram-icon.svg';
import YoutubeIcon from 'inside-out/images/youtube-icon.svg';
import FacebookIconGrey from 'inside-out/images/facebook-icon-grey.svg';
import TwitterIconGrey from 'inside-out/images/twitter-icon-grey.svg';
import InstagramIconGrey from 'inside-out/images/instagram-icon-grey.svg';
import YoutubeIconGrey from 'inside-out/images/youtube-icon-grey.svg';

const SocialIconsComponent = ({
	mode,
	inline,
	justify,
	center,
	width,
	facebook_link,
	twitter_link,
	instagram_link,
	youtube_link,
}) => {
	const hoverImage = (image, hoverImage, alt) => {
		return (
			<img
				src={image}
				alt={alt}
				width={width}
				onMouseOver={e => (e.target.src = hoverImage)}
				onMouseOut={e => (e.target.src = image)}
			/>
		);
	};

	if (mode === 'share' && typeof window !== 'undefined') {
		facebook_link = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
			window.location.href
		)}`;
		twitter_link = `https://twitter.com/share?url=${encodeURIComponent(window.location.href)}`;
		//instagram_link = 'https://www.instagram.com/insideout';
		//youtube_link = 'https://www.youtube.com/insideout';
	}

	return (
		<div className={wrapperStyle(inline, width, justify, center)} data-component="SocialIcons">
			{facebook_link && (
				<a href={facebook_link} target="_blank" rel="noopener noreferrer">
					{hoverImage(FacebookIconGrey, FacebookIcon)}
				</a>
			)}
			{twitter_link && (
				<a href={twitter_link} target="_blank" rel="noopener noreferrer">
					{hoverImage(TwitterIconGrey, TwitterIcon)}
				</a>
			)}
			{instagram_link && (
				<a href={instagram_link} target="_blank" rel="noopener noreferrer">
					{hoverImage(InstagramIconGrey, InstagramIcon)}
				</a>
			)}
			{youtube_link && (
				<a href={youtube_link} target="_blank" rel="noopener noreferrer">
					{hoverImage(YoutubeIconGrey, YoutubeIcon)}
				</a>
			)}
		</div>
	);
};

SocialIconsComponent.propTypes = {
	mode: PropTypes.string,
	width: PropTypes.number,
	inline: PropTypes.bool,
	justify: PropTypes.bool,
	center: PropTypes.bool,
	facebook_link: PropTypes.string,
	twitter_link: PropTypes.string,
	instagram_link: PropTypes.string,
	youtube_link: PropTypes.string,
};

SocialIconsComponent.defaultProps = {
	width: 25,
	inline: false,
};

export const SocialIcons = SocialIconsComponent;



// WEBPACK FOOTER //
// ./src/components/shared/socialIcons/component.js